import * as yup from 'yup';
import { ValidationMessages } from 'shared/models/Validation';

export const ValidationsSchema = yup.object().shape({
    name: yup.string().trim().required(ValidationMessages.REQUIRED),
    employer_id: yup.string().trim().nullable(),
    cost_center: yup.string().trim().nullable(),
    status: yup.object().nullable(),
    status_date: yup.string().trim(),
    service_type: yup.string().trim(),
    payroll_rep_user: yup.object().nullable(),
    manager: yup.object().nullable(),
    address: yup.string().nullable().trim(),
    address2: yup.string()
        .trim().nullable(),
    city: yup.string().trim().nullable(),
    state: yup.string().trim().nullable(),
    county: yup.string().trim().nullable(),
    zip_code: yup.string().trim().nullable(),
    contact_name: yup.string().nullable().when(['contact_title', 'contact_email', 'contact_phone'],
        (contact_title: string, contact_email: string, contact_phone: string) => {
            if ( contact_title || contact_email || contact_phone) {
                return yup.string().nullable().required('Contact name can not be empty');
            }
            return yup.string().nullable();
        }),
    contact_email: yup.string().nullable().email('Please enter valid email'),
    contact_phone: yup.string().nullable().min(10, 'Please enter valid phone'),
    prism_corporation_type: yup.string().nullable(),
});
